import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import "metismenu"

// Applique metisMenu au <ul> du menu latéral — le plugin jQuery qu'utilise le
// gabarit Skote pour son menu repliable (un groupe à chevron qui se déplie, ex.
// « Sécurité & accès » -> Rôles / Fonctionnalités / Permissions). Importer
// "metismenu" enregistre $.fn.metisMenu ; son apparence vient du SCSS de Skote
// (skote/custom/structure/_vertical.scss), pas de metisMenu.css.
//
// Version figée à metismenu@3.0.7 dans package.json : la 3.1.0 exige jQuery >= 4.
export default class extends Controller {
  connect() {
    this.highlightActiveItem()
    this.$el = $(this.element)
    this.$el.metisMenu()
  }

  disconnect() {
    if (this.$el && this.$el.data("metisMenu")) this.$el.metisMenu("dispose")
  }

  // Marque l'entrée de la page courante (le chemin le plus long l'emporte :
  // /admin/posts/12/edit allume « Articles ») et déplie le groupe qui la contient.
  highlightActiveItem() {
    const currentPath = window.location.pathname
    let bestMatch = null
    let bestMatchLength = -1

    this.element.querySelectorAll("a[href]").forEach((link) => {
      const href = link.getAttribute("href")
      if (!href || href === "#" || href.startsWith("javascript:")) return

      const linkPath = new URL(href, window.location.origin).pathname
      const isMatch = linkPath === currentPath || currentPath.startsWith(linkPath + "/")
      if (isMatch && linkPath.length > bestMatchLength) {
        bestMatch = link
        bestMatchLength = linkPath.length
      }
    })
    if (!bestMatch) return

    bestMatch.classList.add("active")
    bestMatch.closest("li")?.classList.add("mm-active")

    const subMenu = bestMatch.closest("ul.sub-menu")
    if (subMenu) {
      subMenu.classList.add("mm-show")
      const group = subMenu.closest("li")
      group?.classList.add("mm-active")
      group?.querySelector(":scope > a")?.classList.add("mm-active")
    }
  }
}
